import { cx } from '../../lib/util/cx';

/**
 * On/off switch. The DS has no toggle component; this uses its tokens —
 * brown track when on (the SelectableChip active fill), gray-300 when off,
 * white thumb, orange focus ring from the global rule.
 */
export interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  disabled?: boolean;
  /** `sm` sits beside small text in a header (e.g. a map card's controls). */
  size?: 'md' | 'sm';
}

const SIZE = {
  md: { track: 'h-6 w-11', thumb: 'h-5 w-5', on: 'translate-x-[22px]', off: 'translate-x-0.5' },
  sm: { track: 'h-4 w-7', thumb: 'h-3 w-3', on: 'translate-x-[14px]', off: 'translate-x-0.5' },
};

export function Switch({ checked, onChange, label, disabled = false, size = 'md' }: SwitchProps) {
  const z = SIZE[size];
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={cx(
        'relative inline-flex shrink-0 items-center rounded-pill border-0 p-0 transition-colors duration-fast',
        'disabled:cursor-not-allowed disabled:opacity-50',
        z.track,
        checked ? 'bg-brown' : 'bg-[var(--hp-gray-300)]',
      )}
    >
      <span
        aria-hidden="true"
        className={cx(
          'inline-block rounded-full bg-white shadow-card transition-transform duration-fast',
          z.thumb,
          checked ? z.on : z.off,
        )}
      />
    </button>
  );
}
